import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  IExperience,
  IExperienceTemplate
} from '@dadohr/shared/domainTypes/experience';
import { Timestamp } from '@dadohr/shared/domainTypes/time';
import { Button, MenuItem, Select } from '@material-ui/core';
import { useState } from 'react';
import { DateTimeFieldNullable } from '../../../../../components/Time/DateTimeField';
import { useUnsafeTranslation } from '../../../../../i18next';
import { FlexContainer } from '../../../../../layout/Flex';
import { moveSelectedExperienceItemsRelatively } from '../../../../../services/experiences/instance';
import { now, ONE_DAY } from '../../../../../services/time';
import { Duration } from '../../../components/Builders/TaskBuilder/components/TimeSelectors';

const ALLOW_ABSOLUTE_CHANGES = false;

export const CustomizeDates = ({
  tpl,
  exp,
  selections,
  onChange
}: {
  tpl: Doc<IExperienceTemplate>;
  exp: Doc<IExperience>;
  selections: {
    tasks: { [taskId: string]: boolean };
    automations: { [aId: string]: boolean };
    messages: { [msgId: string]: boolean };
  };
  onChange: React.Dispatch<React.SetStateAction<Doc<IExperience>>>;
}) => {
  const { t } = useUnsafeTranslation();

  const [state, setState] = useState<{
    absoluteDate: Timestamp | null;
    move: number;
  }>({
    absoluteDate: null,
    move: 1 * ONE_DAY
  });

  const moveRelatively = (msToMove: number) => {
    onChange((x) => {
      return moveSelectedExperienceItemsRelatively(
        tpl,
        x,
        selections,
        msToMove,
        now()
      );
    });
  };

  const moveAbsolutely = (ts: Timestamp) => {};
  const [moveDirection, setMoveDirection] = useState('later');

  return (
    <>
      {ALLOW_ABSOLUTE_CHANGES ? (
        <FlexContainer>
          <div>{t('Run all on')}</div>

          <DateTimeFieldNullable
            value={state.absoluteDate}
            onChange={(ts) => {
              setState((s) => ({ ...s, absoluteDate: ts }));
            }}
            tz={tpl.data.tz}
          />
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 'auto' }}
            disabled={!state.absoluteDate}
            onClick={() =>
              state.absoluteDate && moveAbsolutely(state.absoluteDate)
            }
          >
            {t('Apply')}
          </Button>
        </FlexContainer>
      ) : (
        <FlexContainer>
          <div>{t('Move to')}</div>

          <Duration
            value={state.move}
            onChange={(ev) =>
              setState((s) => ({
                ...s,
                move: ev
              }))
            }
          ></Duration>
          <Select
            value={moveDirection}
            onChange={(ev) => setMoveDirection(ev.target.value as string)}
          >
            <MenuItem value="earlier">Earlier</MenuItem>
            <MenuItem value="later">Later</MenuItem>
          </Select>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              moveRelatively(
                moveDirection === 'earlier' ? -state.move : state.move
              );
            }}
          >
            {t('Move items')}
          </Button>
        </FlexContainer>
      )}
    </>
  );
};
